import React, { Component } from 'react'
import { DraggableContainer } from './styledComponents';
import Icon from '../Icon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { colors } from 'globalStyles';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default class DraggableList extends Component {
  state = {
    selected: []
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.props.data,
      result.source.index,
      result.destination.index
    );

    this.listChanged(items);
  }

  // Report WHICH row was removed alongside what remains. The consumer needs the
  // removal itself, not a diff it has to reconstruct — reconstructing it needs
  // a baseline, and a lost baseline reads as a phantom delete.
  //
  // Identified by INDEX, not by value: two rows can carry the same display
  // value (e.g. the same image staged on a channel twice). Filtering by value
  // would drop BOTH rows and leave the consumer unable to tell which one the
  // user clicked, so it could delete the wrong record.
  onDeleteItem = (item, index) => {
    const { data } = this.props;
    const remaining = Number.isInteger(index)
      ? data.filter((_x, i) => i !== index)
      : data.filter(x => x !== item);

    this.listChanged(remaining, { value: item, index })
  }

  onToggleSelect = (item) => {
    var list = this.state.selected.find(x => x === item) ? [] : [item];

    this.setState({ selected: list }, () => {
      const { listSelectChanged } = this.props;
      listSelectChanged && listSelectChanged(list.filter(x => !Array.isArray(x)));
    })
  }

  // `removedItem` is undefined for every path except a delete (the reorder path
  // above calls this with one argument), so a reorder records no deletion.
  listChanged = (list, removedItem) => {
    const { listChanged } = this.props;
    listChanged && listChanged(list.filter(x => !Array.isArray(x)), removedItem);
  }

  componentDidMount() {
    this.setState({ data: this.props.data })
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    try {
      if ((data && !prevProps.data) || (data && prevProps.data.length !== data.length) || (data && JSON.stringify(prevProps.data) !== JSON.stringify(data))) {
        this.setState({ selected: [data[0]] })
      }
    } catch (error) {
      //ignore
    }
  }

  getValueStr = (path) => {
    var isImagePath = path && (path.includes("png") || path.includes("jpg"));
    var result = isImagePath ? path.replace(/\?.*/g, "") : path;
    var pathSplits = result ? result.split('/') : [];

    return isImagePath && pathSplits ? pathSplits[pathSplits.length-1] : path;
  }

  render() {
    const { className, data } = this.props;
    const { selected } = this.state;

    return data && data.filter(x => x && x !== null).length > 0 && Array.isArray(data) ? (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <DraggableContainer dataCount={data ? data.filter(x => !Array.isArray(x) && x !== null).length : null}>
              <ul className={className}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {data.map((item, idx) => {
                  const name = this.getValueStr(item);
                  const isSelected = Boolean(selected.find(x => x === item));
                  return !Array.isArray(item) && item !== null && (
                  <Draggable key={idx} draggableId={`${idx}`} index={idx}>
                    {(childProvided, snapshot) => (
                      <li
                        ref={childProvided.innerRef}
                        {...childProvided.draggableProps}
                        {...childProvided.dragHandleProps}
                      >
                        <div className='left'>
                          <button
                            type='button'
                            className='select-action'
                            aria-pressed={isSelected}
                            aria-label={`Select ${name}`}
                            onClick={() => this.onToggleSelect(item)}
                          >
                            <Icon size='16' name='image' fill={isSelected && colors.GREEN} />
                            <div className='value'>{name}</div>
                          </button>
                        </div>
                        <button
                          type='button'
                          className='right-action'
                          aria-label={`Remove ${name}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.onDeleteItem(item, idx);
                          }}
                        >
                          <Icon name='x' size='10' />
                        </button>
                      </li>
                    )}
                  </Draggable>
                )})}
                {provided.placeholder}
              </ul>
            </DraggableContainer>
          )}
        </Droppable>
      </DragDropContext>
    ) : null;
  }
}